import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  ViewChild,
} from '@angular/core';

import { LanguageService } from '../../../../../core/services/language.service';
import { interval, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ApiHandlerService } from '../../../../../tools/services/api/handler-api/apiHandler.service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { CookieService } from 'ngx-cookie-service';
import {
  EvChargerHistoryInfo,
  EvChargingJob,
  EvStartChargePayload,
  EvStopChargePayload,
  EvChargingStopPayload,
} from '../../../../../core/models/ev.model';
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiEvChargerService } from '../../../../../core/services/api/Ev-chager/api-Ev-Carger';
import { PssWarnComponent } from "../../../../../tools/template/pss/pss-warn/pss-warn.component";

@Component({
  selector: 'app-ev-charger-detail-2',
  imports: [CommonModule, PssLoadingComponent, PssWarnComponent],
  templateUrl: './ev-charger-detail-2.component.html',
  styleUrl: './ev-charger-detail-2.component.css',
})
export class EvChargerDetail2Component {
  sub!: Subscription;
  currentLang: 'TH' | 'EN' = 'TH';
  isOpenCharging = false;
  token: string = '';
  uid: string = '';

  // System
  private intervalId: any;

  // คำนวณค่า ev_battery
  isCharging = false; // เมื่อสถานะชาร์จอยู่
  isConnect = false; // เมื่อสถานะเชื่อมต่อสายอยู่

  // Ev_Charger_HistoryInfo
  evHistoryUuId: string | null = null;
  evChargerHistoryInfo: EvChargerHistoryInfo | null = null;
  evChargerHistoryInfoJob: EvChargingJob | null = null;
  evTimeParking: number | null = 0;
  eclecticDetail = {
    voltage: 120,
    power: 900,
    current: 10,
  };

  // Modal
  showPopupNotice = false;
  showModalEclectic = false;

  // Slide Button
  @ViewChild('sliderContainer', { static: true }) sliderContainer!: ElementRef;
  @ViewChild('sliderHandle', { static: true }) sliderHandle!: ElementRef;

  isDragging = false;
  startX = 0;
  containerWidth = 0;
  handleWidth = 0;
  handleLeft = 0; // ตำแหน่งของปุ่ม
  progress = 0; // %
  status = false; // false = ปิด, true = เปิด
  previousStatus = false;
  statusText = '';
  isLoading = false;

  bubbles = Array(5).fill(0); // จำนวนฟองน้ำ

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  warnImageSrc: string = 'images/ev_icon.png'
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private apiHandler: ApiHandlerService,
    private apiEvChargerService: ApiEvChargerService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private cookieService: CookieService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
  }
  ngOnInit(): void {
    // ถ้า status เป็น true → handle ไปสุดขวา
    //this.updatePosition();

    this.evHistoryUuId = this.router.url.split('/').pop() ?? null;
    if (this.evHistoryUuId) {
      this.getInfoEvChargerByJobId();
    }
  }
  ngAfterViewInit() {
    this.containerWidth = this.sliderContainer.nativeElement.offsetWidth;
    this.handleWidth = this.sliderHandle.nativeElement.offsetWidth;
  }

  onInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      this.getInfoEvChargerByJobId();
    }, 7000);
  }
  onIntervalChargingIsReady() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      this.getInfoEvChargerByJobId();
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  startDrag(event: MouseEvent | TouchEvent) {
    this.isDragging = true;
    this.startX =
      event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
  }

  /*----------------------------------------------------------- Function ---------------------------------------------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.Error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess(text, detail)
  }

  showPopupWarn(message: string, detail: string = '') {
    this.isWarning = true
    this.textWarn = message
    this.detailWarn = detail
  }



  /* --- Function --- */
  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])
  onDrag(event: MouseEvent | TouchEvent) {
    if (!this.isDragging) return;

    const clientX =
      event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;

    let newLeft =
      clientX -
      this.startX +
      (this.isCharging ? this.containerWidth - this.handleWidth : 0);

    if (newLeft < 0) newLeft = 0; // เลื่อนซ้ายสุด
    if (newLeft > this.containerWidth - this.handleWidth)
      // เลื่อนขวาสุด
      newLeft = this.containerWidth - this.handleWidth;

    this.handleLeft = newLeft;
    this.progress =
      (this.handleLeft / (this.containerWidth - this.handleWidth)) * 100;
  }

  @HostListener('document:mouseup')
  @HostListener('document:touchend')
  stopDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;

    const middle = (this.containerWidth - this.handleWidth) / 2;

    if (this.handleLeft > middle) {
      this.status = true;
    } else {
      this.status = false;
    }

    this.updatePosition();
  }

  private updatePosition() {
    if (this.status) {
      this.handleLeft = this.containerWidth - this.handleWidth;
      this.progress = 100;
      this.statusText =
        this.currentLang === 'TH'
          ? 'เลื่อนเพื่อหยุดชาร์จรถ'
          : 'Slide for stop charging';
      this.isOpenCharging = true;
    } else {
      this.handleLeft = 0;
      this.progress = 0;
      this.statusText =
        this.currentLang === 'TH'
          ? 'เลื่อนเพื่อเริ่มชาร์จรถ'
          : 'Slide for start charging';
      this.isOpenCharging = false;
    }

    // ตรวจสอบว่าเลื่อนปุ่มถสุด ซ้าย ขวา ไหม
    if (this.previousStatus !== this.status) {
      // ตรวจสอบว่าเลื่อน ปิด หรือ เปิด
      // เปิด
      if (this.status) {
        const payload: EvStartChargePayload = {
          transaction_ev_id: this.evChargerHistoryInfo?.id ?? 0,
          line_OA_uid: this.uid,
          site_id: this.evChargerHistoryInfo?.siteEv ?? '',
          license: this.evChargerHistoryInfo?.licensePlate ?? '',
        };
        this.previousStatus = this.status;
        this.sentApiStatusStartEvCharger(payload);
      }
      // ปิด
      else {
        const payload: EvStopChargePayload = {
          jobId: this.evChargerHistoryInfoJob?.jobId ?? '',
        };
        this.previousStatus = this.status;
        this.sentApiStatusStopEvCharger(payload);
      }
    }
  }
  resetPosition() {
    this.isDragging = false;
    this.isCharging = false;
    this.status = false;
    this.isOpenCharging = false;
    this.previousStatus = false;
    this.handleLeft = 0;
    this.progress = 0;
    this.statusText =
      this.currentLang === 'TH'
        ? 'เลื่อนเพื่อเริ่มชาร์จรถ'
        : 'Slide for start charging';
  }
  openPosition() {
    this.isCharging = true;
    this.status = true;
    this.isOpenCharging = true;
    this.previousStatus = true;
    this.handleLeft = this.containerWidth - this.handleWidth;
    this.progress = 100;
    this.statusText =
      this.currentLang === 'TH'
        ? 'เลื่อนเพื่อหยุดชาร์จรถ'
        : 'Slide for stop charging';
    console.log('openPosition', this.handleLeft);
  }
  cal_ev_battery(percent: number) {
    const result = 565.48 * (1 - percent / 100);
    //console.log('cal_ev_battery:', percent, result);
    return result;
  }
  onClickShowPopupNotice() {
    if (this.showPopupNotice) {
      this.showPopupNotice = false;
      return;
    }

    this.showPopupNotice = !this.showPopupNotice;
    setTimeout(() => {
      this.showPopupNotice = false;
    }, 5000);
  }
  goback() {
    this.router.navigate(['/ev-charger']);
  }
  validateStatus(status: boolean) {
    // ตรวจสอบสถานะ ชาร์จ เปิด/ปิด
    if (status) {
      // ปุ่มเลื่อนเปิด
      this.openPosition();
    } else {
      // ปุ่มเลื่อนปิด
      this.resetPosition();
    }
  }

  /* --- EvChargerHistoryInfo --- */

  setValueEvChargerHistoryInfo(evChargerHistoryInfo: EvChargerHistoryInfo) {
    this.evChargerHistoryInfo = evChargerHistoryInfo;
    this.evChargerHistoryInfoJob = evChargerHistoryInfo.evChargingJob ?? null;
    this.evTimeParking =
      evChargerHistoryInfo.evChargingJob?.totalTimeMinutes ?? 0;
    this.isCharging = evChargerHistoryInfo.chargingIsReady ?? false;
  }

  get displayHours(): number | null {
    return this.evTimeParking !== null && this.evTimeParking !== undefined
      ? Math.floor(this.evTimeParking / 60)
      : null;
  }

  get displayMinutes(): number | null {
    return this.evTimeParking !== null && this.evTimeParking !== undefined
      ? this.evTimeParking % 60
      : null;
  }

  // setValueEvChargerHistoryInfo(evChargerHistoryInfo: EvChargerHistoryInfo) {
  //   this.evChargerHistoryInfo = evChargerHistoryInfo;
  //   this.evChargerHistoryInfoJob = evChargerHistoryInfo.evChargingJob ?? null;
  //   this.evTimeParking =
  //     evChargerHistoryInfo.evChargingJob?.totalTimeMinutes ?? 0;
  //   this.isCharging = evChargerHistoryInfo.chargingIsReady ?? false;
  // }

  // get displayHours(): number | null {
  //   return this.evTimeParking ? Math.floor(this.evTimeParking / 60) : null;
  // }

  // get displayMinutes(): number | null {
  //   return this.evTimeParking ? this.evTimeParking % 60 : null;
  // }

  /* -------------------------------------------- API -------------------------------------------- */
  /* ยิงครั้งแรก */
  getInfoEvChargerDetailByJobId() {
    this.apiHandler.handleApi(
      this.apiEvChargerService.getInfoEvChargerDetailByJobId(
        this.evHistoryUuId ?? '',
        this.uid,
        this.token
      ),
      {
        logLabel: 'GetInfoEvChargerDetailByJobId',
        success: (response) => {
          if (response.jobId) {
            // ตรวจสอบมีการเลื่อนอยู่ไหมไม่ให้เกิดบัค
            if (!this.isDragging) {
              // ตรวจสอบการเริ่มชาร์จ
              if (
                this.evChargerHistoryInfo?.chargingIsReady &&
                response?.jobId != null
              ) {
                this.validateStatus(true);
              } else {
                this.validateStatus(false);
                clearInterval(this.intervalId);
              }
            }
            this.evChargerHistoryInfoJob = response;
          }
        },
        error: () => {
          this.resetPosition();
        },
        isConsoleLog: true,
      }
    );
  }
  /* ยิงทุกๆ 7 วิ */
  getInfoEvChargerByJobId() {
    if (this.uid) {
      this.apiHandler.handleApi(
        this.apiEvChargerService.getInfoEvChargerByJobId(
          this.evHistoryUuId ?? '',
          this.uid,
          this.token
        ),
        {
          logLabel: 'getInfoEvChargerByJobId',
          loading: (loading) => (false),
          success: (response: EvChargerHistoryInfo) => {
            this.statusText = 'เสียบหัวชาร์จก่อนเริ่มใช้งาน';

            // ใส่ค่าตัวแปร
            this.setValueEvChargerHistoryInfo(response);
            // ตรวจสอบเสียบหัวชาร์จ
            if (response.chargingIsReady) {
              this.isConnect = true;

              // ตรวจสอบการเริ่มชาร์จ
              if (response.evChargingJob?.jobId != null && response.evChargingJob?.jobId) {
                this.validateStatus(true);
                // ยิงถาม API รัวๆ
                this.onInterval();
                // clearInterval(this.intervalId)
              } else {
                this.validateStatus(false);
              }

            } else {
              this.validateStatus(false);
              this.isConnect = false;
              this.onIntervalChargingIsReady();
              this.statusText = 'เสียบหัวชาร์จก่อนเริ่มใช้งาน';
            }
          },
          error: (err) => {
            this.isConnect = false;
            this.statusText = 'เสียบหัวชาร์จก่อนเริ่มใช้งาน';
            this.resetPosition();
            this.showError(
              this.currentLang === 'TH'
                ? 'โหลดข้อมูลล้มเหลว'
                : 'Failed to load data.'
            );
          },
          isConsoleLog: true,
        }
      );
    }
  }


  sentApiStatusStartEvCharger(payload: EvStartChargePayload) {
    this.apiHandler.handleApi(
      this.apiEvChargerService.sentApiStatusStartEvCharger(this.token, payload),
      {
        logLabel: 'Ev Charger Start Status Response',
        loading: (loading) => (this.isLoading = loading),
        success: (res) => {
          if (res.status === 'success') {
            this.validateStatus(true);
            // ยิงรอบแรกเพื่อไม่ต้องรอเวลา 7 วิ
            this.getInfoEvChargerDetailByJobId();
            this.onInterval();
            this.showPopupWarn(
              this.currentLang === 'TH' ? "คำเตือน" : "Warning",
              this.currentLang === 'TH' ? "กรุณาตรวจสอบว่าเครื่องชาร์จกำลังชาร์จเรียบร้อย ก่อนออกจากลานจอด" : "Please make sure the charger has started charging successfully before leaving the parking area."
            );
          } else {
            this.validateStatus(false);
            clearInterval(this.intervalId);
            this.showWarning(this.currentLang === 'TH' ? res.message : res.message_en);
          }
        },
        error: () => {
          this.resetPosition();
          this.showError(
            this.currentLang === 'TH'
              ? 'ส่งข้อมูลล้มเหลว กรุณาลองใหม่อีกครั้ง'
              : 'Data submission failed, please try again.'
          );
        },
        isConsoleLog: true,
      }
    );
  }
  sentApiStatusStopEvCharger(payload1: EvStopChargePayload) {
    const payload: EvChargingStopPayload = {
      jobId: payload1.jobId,
      transaction_ev_id: this.evChargerHistoryInfo?.id ?? 0,
      site_id: this.evChargerHistoryInfo?.siteEv ?? '',
      uid: this.uid,
    };
    console.log(payload);
    this.apiHandler.handleApi(
      this.apiEvChargerService.sentApiStatusStopEvCharger(this.token, payload),
      {
        logLabel: 'Ev Charger Stop Status Response',
        loading: (loading) => (this.isLoading = loading),
        success: (res) => {
          if (res.status === 'ok') {
            console.log("pass stop ev charger");
            this.validateStatus(false);
            this.getInfoEvChargerByJobId();
            clearInterval(this.intervalId);
            this.showPopupWarn(
              this.currentLang === 'TH' ? 'สั่งหยุดชาร์จสำเร็จ' : 'Stop charging successfully',
              this.currentLang === 'TH' ? 'กรุณารอสักครู่สถานะกำลังอัพเดท' : 'Please wait a moment for the status to update'
            );
          }
        },
        error: () => {
          this.resetPosition();
          this.showError(
            this.currentLang === 'TH'
              ? 'ส่งข้อมูลล้มเหลว กรุณาลองใหม่อีกครั้ง'
              : 'Data submission failed, please try again.'
          );
        },
        isConsoleLog: true,
      }
    );
  }
}
